<template>
  <div>
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div class="d-flex align-items-end">
        <h3 class="page-header-2">Technicians</h3>
        <span class="ml-1">(+{{ crewMembersCount }} Crew Members)</span>
      </div>
      <div class="d-flex align-items-center unassign-all-link">
        <spinner v-if="saving" class="mr-2"></spinner>
        <div class="link" @click="handleUnassignAll">
          <i class="fas fa-undo mr-1"></i> Clear Technicians Crew Assignments
        </div>
      </div>
    </div>
    <div class="groups-scroll-container">
      <div class="d-flex flex-wrap groups-list">
        <work-crew-group
          v-for="tech in technicians"
          :key="tech.id"
          :technician="tech"
          :crew-members="technicianCrewMembers(tech)"
        ></work-crew-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { getProperty } from "@/lib/helpers.js";

import Spinner from "@/components/Spinner.vue";
import WorkCrewGroup from "./WorkCrewGroup.vue";

export default {
  components: {
    WorkCrewGroup,
    Spinner
  },
  props: {
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      saving: false
    };
  },
  computed: {
    ...mapState({
      crewMembers: "crewMembers",
      technicians({ technicians, department }) {
        return technicians.filter(
          (tech) => tech.department_id === department.id
        );
      },
      crewMembersCount({ crewMembers, department }) {
        return crewMembers.reduce((all, member) => {
          if (
            member.assigned_to &&
            member.assigned_to.department.id === department.id
          ) {
            all += 1;
          }
          return all;
        }, 0);
      }
    })
  },
  methods: {
    ...mapActions(["unassignAllCrewMembers"]),
    handleUnassignAll() {
      this.saving = true;
      this.unassignAllCrewMembers({
        link: this.links.crew_member_unassign_all
      })
        .then(() => {
          EventBus.$emit("refresh-work-crews");
        })
        .finally(() => (this.saving = false));
    },
    technicianCrewMembers(tech) {
      return this.crewMembers.filter(
        (member) =>
          getProperty(member.assigned_to, "technician_id") ===
          tech.technician_profile_id
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.groups-scroll-container {
  height: calc(100% - 55px);
  overflow: scroll;
  margin-left: -10px;
}
.unassign-all-link {
  margin-right: calc(1% + 10px);
}
</style>
